import UE from "./UE";
export default class ObjetoTiempos {
    //0 no hay nada 1 (+2) 2 DNF se acaba el tiempo 20 min
    constructor(id, tiempo, scramble, tipo, comentario){
        this.id = id;
        this.tiempo = tiempo;
        this.scramble = scramble;
        if(tiempo === -1){
            this.tipo = 2;//0 ninguno, 1 mas dos 2 DNF
        }else{
            this.tipo = tipo;
        }
        this.comentario = comentario;
    }

    static crarDesdeJSON(objetoJson){
        return new ObjetoTiempos(objetoJson.id, objetoJson.tiempo, objetoJson.scramble, objetoJson.tipo, objetoJson.comentario);
    }

    idSimple(){
        let res = this.id.replaceAll(" ", "").replaceAll(":", "").replaceAll("-","");
        //console.log(res);
        return res;
    }

    toString() {
        var res = "DNF";
        if (this.tiempo> 0) {
            if (this.tipo !== 2) {//si no es DNF
                //res = convertirTiempoString();
                res = ObjetoTiempos.convertirTiempoString(this.tiempo);
            }
        }
        return res;
    }

    static convertirTiempoDouble(t){
        var res;
        if(t!=="DNF"){
            if(t.length <=5){
                res = Number.parseFloat(t);
            }else{
                var v = t.split(":");
                res = Number.parseInt(v[0])*60 + Number.parseFloat(v[1]);
            }           
        }else{
            res = -1;
        }
        return res;
    }

    static convertirTiempoString(time){
        var res;
        if(time<0){
            res = "DNF";
        }else{
            if (time < 60) {
                res = this.hallarDecimales(time);
            } else {
                var minuto = Number.parseInt(time / 60);
                var sobra = time - minuto * 60;
                sobra = this.fijarNumero(sobra, 2);
                res = minuto + ":" + this.hallarDecimales(sobra);
            }
        }
        return res;
    }

    static hallarDecimales(time) {
        var res;
        var valor = Number.parseInt(time);
        var dec = (this.fijarNumero(time - valor, 2) * 100);
        var decimal = Number.parseInt(this.fijarNumero(dec, 2));
        if (valor < 10) {
            res = "0" + valor + "." + this.completarDecimales(decimal);
        } else {
            res = valor + "." + this.completarDecimales(decimal);
        }
        return res;
    }
    
    static completarDecimales(decimal) {
        var res = "";
        if (decimal < 10) {
            res = "0" + decimal;
        } else {
            res = res + decimal;
        }
        return res;
    }

    static fijarNumero(numero, digitos) {
        var resultado;
        resultado = numero * Math.pow(10, digitos);
        resultado = Math.round(resultado);
        resultado = resultado / Math.pow(10, digitos);
        return resultado;
    }

    fijarNumero(numero, digitos) {
        var resultado;
        resultado = numero * Math.pow(10, digitos);
        resultado = Math.round(resultado);
        resultado = resultado / Math.pow(10, digitos);
        return resultado;
    }

    insertarAdicion(tipo) {

        if (this.tiempo > 0) {
            if (this.tipo === 0 && tipo === 1) {
                this.tiempo = this.tiempo + 2;
                this.fijarNumero();
                this.tipo = tipo;
            } else if (this.tipo === 0 && tipo === 2) {
                this.tipo = tipo;
            } else if (this.tipo === 1 && tipo === 0) {
                this.tiempo = this.tiempo - 2;
                this.fijarNumero();
                this.tipo = tipo;
            } else if (this.tipo === 1 && tipo === 2) {
                this.tiempo = this.tiempo - 2;
                this.fijarNumero();
                this.tipo = tipo;
            } else if (this.tipo === 2 && tipo === 0) {
                this.tipo = tipo;
            } else if (this.tipo === 2 && tipo === 1) {
                this.tiempo = this.tiempo + 2;
                this.fijarNumero();
                this.tipo = tipo;
            } else if(this.tipo === 0 && tipo === 3){
                this.tiempo = this.tiempo+2;
                this.fijarNumero();
            }
        } else {
            this.tipo = 2;
        }

    }

    esMenorQue(objetoTiempos) {
        var res;

        if (this.tipo === 2 && objetoTiempos.tipo === 2) {
            res = 0;
        } else if (this.tipo === 2) {
            res = -1;
        } else if (objetoTiempos.tipo === 2) {
            res = 1;
        } else {
            if(this.tiempo<objetoTiempos.tiempo){
                res = 1
            }else if(this.tiempo>objetoTiempos.tiempo){
                res = -1;
            }else{
                res = 0;
            }
        }

        return res;
    }

    setComentario(nuevoComentario) {
        this.comentario = nuevoComentario;
        console.log("lalalalalalllalala")
    }

    setScramble(scramble){
        this.scramble = scramble;
    }

    static getAoN(tiemposUsuario) {
        var tiemposAoN = tiemposUsuario.slice();
        var totalTiempos = tiemposAoN.length;
        var res = new ObjetoTiempos(UE.getFecha(), -1, "No disponible", 2, "");
        if (totalTiempos === 3 || totalTiempos === 5 || totalTiempos === 12 || totalTiempos === 50 || totalTiempos === 100 || totalTiempos === 1000) {
            //se quitara el doble como: {0,2,2,6,10,100}
            var listaQuitarNumeros = [0, 1, 1, 3, 5, 50];
            var listaCandidatos = [3, 5, 12, 50, 100, 1000];

            var cantidadQuitadaInicioFin = 0;
            for (let i = 0; i < listaCandidatos.length; i++) {
                if (listaCandidatos[i] === totalTiempos) {
                    cantidadQuitadaInicioFin = listaQuitarNumeros[i];
                }
            }

            var cantidadDnfs = 0;
            tiemposAoN.forEach(tiempoActual => {
                if (tiempoActual.toString()==="DNF") {
                    cantidadDnfs = cantidadDnfs+1;
                }
            });

            if (cantidadDnfs <= cantidadQuitadaInicioFin) {
                ObjetoTiempos.ordenarLista(tiemposAoN);
                var tiemposParaPromediar = ObjetoTiempos.obtenerSubLista(tiemposAoN, cantidadQuitadaInicioFin, tiemposAoN.length - cantidadQuitadaInicioFin);
                var sum = 0;
                tiemposParaPromediar.forEach(tiempoActualProm => {
                    sum += tiempoActualProm.tiempo;
                });
                res = new ObjetoTiempos(UE.getFecha(), this.fijarNumero(sum / tiemposParaPromediar.length, 2), "No disponible", 0, "");
            }
        }
        return res;
    }

    static ordenarLista(tiempos) {
        for (var i = 1; i < tiempos.length; i++) {
            for (var j = 0; j < tiempos.length - i; j++) {
                if (tiempos[j].esMenorQue(tiempos[j + 1]) === 1) {
                    let aux = tiempos[j];
                    tiempos[j] = tiempos[j + 1];
                    tiempos[j + 1] = aux;
                }
            }
        }
    }

    static obtenerSubLista(tiempos, ini, fin) {
        var res = [];
        for (let i = ini; i < fin; i++) {
            res.push(tiempos[i]);
        }
        return res;
    }

    static toStringArrayList(tiemposAverage){
        let res = "";
        if(tiemposAverage.length===5){
            let mayor = ObjetoTiempos.hallarMayor(tiemposAverage);
            let menor = ObjetoTiempos.hallarMenor(tiemposAverage);
            for(let i=0;i<tiemposAverage.length;i++){
                if(Object.is(tiemposAverage[i], mayor)||Object.is(tiemposAverage[i], menor)){
                    res = res+"("+tiemposAverage[i].toString()+")";
                }else {
                    res = res+tiemposAverage[i].toString();
                }
                if(i<tiemposAverage.length-1){
                    res = res+"  ";
                }
            }
        }else {
            for(let i=0;i<tiemposAverage.length;i++){
                res = res+tiemposAverage[i].toString();
                if(i<tiemposAverage.length-1){
                    res = res+"  ";
                }
            }
        }
        return res;
    }

    static hallarMayor(tiempos){
        let objetoTiempos = new ObjetoTiempos("default", -1, "L2 L2", 2, "");
        if(tiempos.length>0){
            objetoTiempos = tiempos[0];
            for(let i=1;i<tiempos.length;i++){
                if(tiempos[i].esMenorQue(objetoTiempos)===1){
                    objetoTiempos = tiempos[i];
                }
            }
        }
        return  objetoTiempos;
    }

    static hallarMenor(tiempos){
        let objetoTiempos = new ObjetoTiempos("default", -1, "L2 L2", 2, "");
        if(tiempos.length>0){
            objetoTiempos = tiempos[0];
            for(let i=1;i<tiempos.length;i++){
                if(tiempos[i].esMenorQue(objetoTiempos)===-1){
                    objetoTiempos = tiempos[i];
                }
            }
        }
        return  objetoTiempos;
    }

    static recuperarTiempoScramble(listaMisDatos, AoN, average, nombreCategoria){
        let res = "Cubolandia Timer Online";
        if(listaMisDatos.length===5){
            let mayor = ObjetoTiempos.hallarMayor(listaMisDatos);
            let menor = ObjetoTiempos.hallarMenor(listaMisDatos);
            listaMisDatos.forEach(tiempo => {
                if(Object.is(tiempo,mayor)||Object.is(tiempo,menor)){
                    res = res+"\n\n("+tiempo.toString()+")\n"+tiempo.scramble;
                }else {
                    res = res+"\n\n"+tiempo.toString()+"\n"+tiempo.scramble;
                }
            });
            
        }else {

            listaMisDatos.forEach(tiempo => {
                res = res+"\n\n"+tiempo.toString()+"\n"+tiempo.scramble;
            });

        }
        res = res+"\n\n"+nombreCategoria+" "+AoN+": "+average;
        return res;
    }

}